<!-- Card Mode (showcase style: full image bg + overlay) -->
<div *ngIf="event && cardMode" class="showcase-card" (click)="goToEvent()">
  <img [src]="event.imageUrl" [alt]="'drinkhopping - ' + event.title" class="showcase-card__bg" />
  <div class="showcase-card__gradient"></div>

  <div class="showcase-card__top">
    <span class="showcase-card__badge">{{ event.eventType.name || 'Evento' }}</span>
    <div class="showcase-card__map-btn" (click)="$event.stopPropagation(); mapClick.emit(event.id)">
      <fa-icon [icon]="faMap"></fa-icon>
    </div>
  </div>

  <div class="showcase-card__overlay">
    <h4 class="showcase-card__title">{{ event.title }}</h4>
    <div class="showcase-card__meta">
      <span class="showcase-card__date">
        <fa-icon [icon]="faCalendarAlt"></fa-icon>
        {{ event.date | date: "dd MMM yyyy" }}
      </span>
      <span *ngIf="eventLocation" class="showcase-card__location">
        <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
        {{ eventLocation }}
      </span>
    </div>
    <div class="showcase-card__footer">
      <div class="showcase-card__price">
        <span *ngIf="hasDiscount" class="showcase-card__price--old">{{ event.price | currency }}</span>
        <span class="showcase-card__price--current">{{ finalPrice | currency }}</span>
      </div>
      <div *ngIf="event.eventBranches && event.eventBranches.length > 0" class="showcase-card__breweries">
        <ng-container *ngFor="let eb of event.eventBranches">
          <div class="showcase-card__brewery-logo">
            <img [src]="eb.branch?.brewery?.logoUrl" [alt]="eb.branch?.brewery?.name" />
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Legacy Mode (original horizontal layout) -->
<div *ngIf="event && !cardMode" class="grid grid-cols-1 mobile-m:grid-cols-3 tablet:grid-cols-2 gap-6 py-8 overflow-hidden">
  <div class="mobile-m:hidden col-span-1 flex flex-col justify-start items-center gap-4 pr-0">
    <div class="flex gap-4 w-full">
      <div class="relative w-[140px] h-[140px] flex-shrink-0">
        <img [src]="event.imageUrl" [alt]="'drinkhopping - '+event.title" class="w-full h-full object-cover rounded-lg" />
        <div class="absolute inset-0 flex items-center justify-center bg-black/50 text-[var(--white)] text-sm font-semibold text-[16px/16px] uppercase rounded-l">
          {{ event.eventType.name || "Evento" }}
        </div>
      </div>
      <div class="flex-grow flex flex-col justify-start">
        <h4 class="font-semibold uppercase text-[18px]/[18px]">{{ event.title }}</h4>
        <p [style.white-space]="'pre-line'" class="text-sm overflow-text-wrap max-h-[60px]">{{ event.description }}</p>
      </div>
    </div>
    <div class="flex flex-col justify-start w-full">
      <div class="flex gap-2 items-center">
        <fa-icon [icon]="faCalendarAlt" size="lg"></fa-icon>
        <p class="text-[12px]">Válido hasta: <br/>{{ event.date | date: "dd MMM yyyy" }}</p>
      </div>
      <div class="flex justify-between">
        <div class="flex items-center gap-2">
          <ng-container *ngIf="hasDiscount; else regularPrice">
            <span class="text-[21px]/[52px] font-bold text-[var(--dark-grey)] line-through">{{event.price | currency}}</span>
            <span class="text-[21px]/[52px] font-bold text-[var(--dark-orange)]">{{ finalPrice | currency}}</span>
          </ng-container>
          <ng-template #regularPrice>
            <span class="text-[21px]/[52px] font-bold text-[var(--dark-orange)]">{{event.price | currency}}</span>
          </ng-template>
        </div>
        <app-button [function]="goToEvent.bind(this)" text="Reservar" [styleType]="'secondary'" [fullWidth]="true"></app-button>
      </div>
    </div>
  </div>

  <div class="hidden tablet:col-span-1 mobile-m:col-span-2 col-span-1 mobile-m:flex flex-row justify-start items-center gap-4 pr-0">
    <div class="relative w-[140px] h-[140px] flex-shrink-0">
      <img [src]="event.imageUrl" [alt]="'drinkhopping - '+event.title" class="w-full h-full object-cover rounded-lg" />
      <div class="absolute inset-0 flex items-center justify-center bg-black/50 text-[var(--white)] text-sm font-semibold text-[16px/16px] uppercase rounded-lg">
        {{ event.eventType.name || "Evento" }}
      </div>
    </div>
    <div class="flex-grow flex flex-col justify-between">
      <h4 class="font-semibold uppercase text-[18px]/[18px]">{{ event.title }}</h4>
      <p class="text-sm overflow-text-wrap max-h-[60px]">{{ event.description }}</p>
      <div class="flex justify-between items-center mt-4">
        <div class="flex gap-2 items-center">
          <fa-icon [icon]="faCalendarAlt" size="lg"></fa-icon>
          <p class="text-[12px]">Válido hasta: <br/>{{ event.date | date: "dd MMM yyyy" }}</p>
        </div>
        <div class="flex items-center gap-2">
          <ng-container *ngIf="hasDiscount; else regularPrice2">
            <span class="text-[19px]/[52px] font-bold text-[var(--dark-grey)] line-through">{{event.price | currency}}</span>
            <span class="text-[19px]/[52px] font-bold text-[var(--dark-orange)]">{{ finalPrice | currency}}</span>
          </ng-container>
          <ng-template #regularPrice2>
            <span class="text-[19px]/[52px] font-bold text-[var(--dark-orange)]">{{event.price | currency}}</span>
          </ng-template>
        </div>
        <app-button [function]="goToEvent.bind(this)" text="Reservar" [styleType]="'secondary'" [fullWidth]="true"></app-button>
      </div>
    </div>
  </div>

  <div class="col-span-1 flex flex-col justify-center items-start">
    <h4 class="mb-4 uppercase text-[14px]/[36px] font-medium">Participan en este evento</h4>
    <div class="grid grid-cols-5 mobile:grid-cols-8 mobile-m:grid-cols-5 tablet:grid-cols-8 gap-2 w-full">
      <ng-container *ngFor="let eventBranch of event.eventBranches">
        <div class="bg-[var(--white)] group relative rounded-lg overflow-hidden transition-transform transform hover:scale-110">
          <img [src]="eventBranch.branch?.brewery?.logoUrl" [alt]="'drinkhopping - '+eventBranch.branch?.brewery?.name" class="w-full h-full object-cover" />
        </div>
      </ng-container>
    </div>
  </div>
</div>
